import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Navbar from './components/dashboard/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Dashboard } from './views/dashboard/Dashboard';
import Reports from './views/reports/Reports';
import Roles from './views/roles/Roles';
import Users from './views/users/Users';
import Clients from './views/clients/Clients';
import InbursaUsers from './views/inbursa/inbursausers/InbursaUsers';
import InbursaProspects from './views/inbursa/inbursaprospects/InbursaProspects';
import InbursaTemplates from './views/inbursa/inbursatemplates/InbursaTemplates';
import InbursaUsersLogin from './views/inbursa/inbursauserslogin/InbursaUsersLogin';
import Plans from './views/plans/Plans';
import PayMethods from './views/catalogs/paymethods/PayMethods';
import Templates from './views/templates/Templates';
import Orders from './views/orders/Orders';
import Logs from './views/logs/Logs';
import ListSsl from './views/listssl/ListSsl';
import MonitorUrls from './views/reports/monitorUrls/MonitorUrls';
import { Login } from './views/login/Login';
import { NotFound } from './views/pages/NotFound';
import useToken from './components/app/useToken';
import GoogleAnalyticsReport from './views/reports/analytics/GoogleAnalyticsReport';
import { Subscriptions as CoutSubscriptions } from './views/reports/Subscriptions';
import Subscriptions from './views/logs/Subscriptions';


function App() {

  const {token, setToken} = useToken();

  if(!token) {
    return <Login setToken={setToken} />
  }

  return (
  <>
      <Router>
        <Navbar />
        <Routes>
          <Route path='/' exact element={<Dashboard />} />
          <Route path='/reports' element={<Reports />} />
          <Route path='/reports/analytics' element={<GoogleAnalyticsReport />} />
          <Route path='/reports/subscriptions' element={<CoutSubscriptions />} />
          <Route path='/roles' element={<Roles />} />
          <Route path='/users' element={<Users />} />
          <Route path='/clients' element={<Clients />} />
          <Route path='/reports/inbursausers' element={<InbursaUsers />} />
          <Route path='/inbursa/prospects' element={<InbursaProspects />} />
          <Route path='/inbursa/templates' element={<InbursaTemplates />} />
          <Route path='/inbursa/userslogin' element={<InbursaUsersLogin />} />
          <Route path='/plans' element={<Plans />} />
          <Route path='/catalogs/paymethods' element={<PayMethods />} />
          <Route path='/templates' element={<Templates />} />
          <Route path='/monitorurls' element={<MonitorUrls />} />
          <Route path='/orders' element={<Orders />} />
          <Route path='/logs' element={<Logs />} />
          <Route path='/logs/listSsl' element={<ListSsl />} />
          <Route path='/logs/orders' element={<Orders defaultFilter={{statusT1Pagos: '0' }}/>} />
          <Route path='/logs/subscriptions' element={<Subscriptions />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
